import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";

export const GlobalContext = createContext();

export const GlobalProvider = (props) => {
  // Storing Data Job Vacancy
  const [data, setData] = useState([]);
  const [fetchStatus, setFetchStatus] = useState(true);

  // Storing Data User Register and Login
  const [user, setUser] = useState(
    Cookies.get("user") ? JSON.parse(Cookies.get("user")) : null
  );

  // Use Effectnya Job Vacancy
  useEffect(() => {
    if (fetchStatus === true) {
      const fetchData = async () => {
        try {
          const res = await axios.get(
            "https://dev-example.sanbercloud.com/api/job-vacancy"
          );
          const resultData = res.data.data.map((vacancyData) => {
            let {
              id,
              title,
              job_description,
              job_qualification,
              job_type,
              job_tenure,
              job_status,
              company_name,
              company_image_url,
              company_city,
              salary_min,
              salary_max,
            } = vacancyData;
            return {
              id,
              title,
              job_description,
              job_qualification,
              job_type,
              job_tenure,
              job_status,
              company_name,
              company_image_url,
              company_city,
              salary_min,
              salary_max,
            };
          });

          setData(resultData);
          setFetchStatus(false);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      fetchData();
    }
  }, [fetchStatus]);

  // Cookie
  const updateUserData = (userData, token) => {
    setUser(userData);
    Cookies.set("user", JSON.stringify(userData), { expires: 7 });
    Cookies.set("token", token, { expires: 7 });
  };

  // Remove Cookie
  const handleLogout = () => {
    setUser(null);
    Cookies.remove("user");
    Cookies.remove("token");
  };

  const state = {
    data,
    setData,
    user,
    setUser,
    fetchStatus,
    setFetchStatus,
  };

  const handleFunction = {
    updateUserData,
    handleLogout,
    setFetchStatus,
  };

  return (
    <GlobalContext.Provider value={{ state, handleFunction }}>
      {props.children}
    </GlobalContext.Provider>
  );
};
